import React, { useState } from "react";
import Box from "../../Box/Box";
import Flex from "../../Flex/Flex";
import { PrimaryButton } from "../../Button/PrimaryButton";
import { SecondaryOutlinedButton } from "../../Button/SecondaryButton";
import Paper from "../../Paper/Paper";
import Calendar from "./Calendar";
import DigitalTime from "../Time/Time";

const CalendarWithTime = ({ defaultDate, is24Hr = false, withActions = false, onChange, onApply, applyLabel = "Apply", cancelLabel = "Cancel", onCancel, ...props }) => {
  const [date, setDate] = useState(defaultDate);

  const handleChange = (newDate) => {
    setDate(newDate);

    if (onChange) {
      onChange(newDate);
    }
  };

  const handleApply = () => {
    if (typeof onApply === "function") {
      onApply(date);
    }
  };

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  const renderDigitalTime = () => {
    if (withActions) {
      return (
        <>
          <Box borderBottomStyle="solid" borderWidth={1} borderColor="mediumShade">
            <DigitalTime defaultDate={date} is24Hr={is24Hr} onChange={handleChange} elevation={0} bg="white" />
          </Box>
          <Flex p={2} justifyContent="end" alignItems="center">
            <SecondaryOutlinedButton borderRadius="8px" mr={3} onClick={handleCancel}>
              {cancelLabel}
            </SecondaryOutlinedButton>
            <PrimaryButton borderRadius="8px" onClick={handleApply}>
              {applyLabel}
            </PrimaryButton>
          </Flex>
        </>
      );
    }

    return <DigitalTime defaultDate={date} is24Hr={is24Hr} onChange={handleChange} elevation={0} bg="white" />;
  };

  return (
    <Paper elevation={1} width="320px" bg="white" {...props}>
      <Box borderBottomStyle="solid" borderWidth={1} borderColor="mediumShade">
        <Calendar defaultDate={date} onChange={handleChange} elevation={0} bg="white" {...props} />
      </Box>
      {renderDigitalTime()}
    </Paper>
  );
};

export default CalendarWithTime;
